export default __webpack_public_path__ + "static/media/puitstermineActual.bea72edb.png";